import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/service/users.service';
import { ToastrNotificationService } from 'src/app/service/toastr-notification.service';

@Component({
  selector: 'app-add-edit-notification',
  templateUrl: './add-edit-notification.component.html',
  styleUrls: ['./add-edit-notification.component.scss'],
})
export class AddEditNotificationComponent {
  public fcmTokens: string[] = [];
  public isSubmitting = false;
  public notificationForm = new FormGroup({
    title: new FormControl('', [Validators.required, Validators.minLength(3)]),
    message: new FormControl('', [Validators.required, Validators.minLength(10)]),
    image: new FormControl(),
  });
  public preview = '';
  public currentFile: any;
  public imageBase64: string = '';

  constructor(
    private usersService: UsersService,
    private router: Router,
    private titleService: Title,
    private toastr: ToastrNotificationService
  ) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.fcmTokens = navigation.extras.state['fcmTokens'] || [];
    };
  };

  ngOnInit(): void {
    this.titleService.setTitle('Add Notification');
  };

  onAdd() {
    if (this.isSubmitting) {
      return;
    };

    this.isSubmitting = true;

    const requestData: any = {
      fcmTokens: this.fcmTokens,
      title: this.notificationForm.value.title || '',
      body: this.notificationForm.value.message || ''
    };

    if (this.imageBase64) {
      requestData.image = this.imageBase64;
    };

    this.usersService.sendBulkNotification(requestData).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        this.toastr.success('Notification sent successfully', 'Success');
        this.router.navigate(['../notifications']);
      },
      error: (error) => {
        this.isSubmitting = false;
        this.toastr.error(
          error.message || 'Failed to send notification',
          'Error'
        );
      }
    });
  };

  onFileSelected(event: any) {
    const selectedFiles = event.target.files;
    if (selectedFiles) {
      const file: File | null = selectedFiles.item(0);

      if (file) {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!validTypes.includes(file.type)) {
          this.toastr.error('Only JPG, JPEG, and PNG images are allowed', 'Invalid File Type');
          event.target.value = '';
          this.preview = '';
          this.currentFile = null;
          this.imageBase64 = '';
          return;
        };

        const maxSize = 20 * 1024 * 1024; // 20MB
        if (file.size > maxSize) {
          this.toastr.error('Image size should not exceed 20MB', 'File Too Large');
          event.target.value = '';
          this.preview = '';
          this.currentFile = null;
          this.imageBase64 = '';
          return;
        };

        this.preview = '';
        this.currentFile = file;
        this.imageBase64 = '';

        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.preview = e.target.result;
          this.imageBase64 = e.target.result;
        };

        reader.readAsDataURL(this.currentFile);
      };
    };
  };

  onSubmit() {
    if (this.notificationForm.valid) {
      this.onAdd();
    };
  };
}

